import { createI18n } from "vue-i18n";

import { numberFormats } from "./formats/numberFormats";

//translation
import { ENGLISH_TRANSLATIONS } from "./en";
// import { ENGLISH_TRANSLATIONS } from "./EOen";
// import { ENGLISH_TRANSLATIONS } from "./SOen";
// import { ENGLISH_TRANSLATIONS } from "./CHen";
// import { ENGLISH_TRANSLATIONS } from "./BEen";
// import { ENGLISH_TRANSLATIONS } from "./TLen";

//translation
const TRANSLATION = {
  "en-NG": ENGLISH_TRANSLATIONS,
};

//Usage
//number format = $n(123, 'currency') or translateText('path')
//text format = $t("calendar.selectDate") or  currencyFormat(900, "currencyCode" or "currencySymbol")
export const i18n = createI18n({
  locale: "en-NG",
  fallbackLocale: "en-NG",
  messages: TRANSLATION,
  numberFormats,
});

//external functions

// export const getCurrencySymbol = () => {
//   const formatted = i18n.global.n(0, "currencySymbol");
//   return formatted.replace(/[0-9.,\s]/g, "");
// };

export const getCurrencySymbol = () => {
  try {
    const entityDetails = JSON.parse(localStorage.getItem("entityDetails"));
    return entityDetails?.currencyCode || "₦"; // Default to ₦ if not found
  } catch (error) {
    return "₦"; // Default symbol in case of error
  }
};
